import { useState, useEffect, useCallback } from 'react';
import useAxios from './useAxios';
import { useDownloadOptions } from './useDownloadOptions';
import Constants from '../Constants';

const usePreliminaryLifecareStatus = ({ caseId, caseName }) => {
    const { getData } = useAxios();
    const { downloadCertifiedLifecarePlan } = useDownloadOptions();
    const [requested, setRequested] = useState(false);
    const [finalized, setFinalized] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);

    const loadStatus = useCallback(async () => {
        if (!caseId) return;
        try {
            const { success, data } = await getData(`${Constants.ApiUrl.costProjection.status}/${caseId}`);
            if (!success) return;
            setRequested(Boolean(data?.preliminaryLifecare?.requested));
            setFinalized(Boolean(data?.preliminaryLifecare?.finalized));
        } catch {
            console.error('Failed to load preliminary lifecare status');
        }
    }, [caseId, getData]);

    useEffect(() => {
        loadStatus();
    }, [loadStatus]);

    const downloadZip = async () => {
        setIsDownloading(true);
        try {
            await downloadCertifiedLifecarePlan({ caseId, caseName });
        } finally {
            setIsDownloading(false);
        }
    };

    return { requested, finalized, isDownloading, downloadZip };
};

export default usePreliminaryLifecareStatus;
